import { useEffect, useState } from 'react';

const NAVBAR_HEIGHT = 70;

export const useScrollUpVisible = () => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const toggleVisible = () => {
			const scrolled = document.documentElement.scrollTop;
			setVisible(scrolled > NAVBAR_HEIGHT);
		};

		window.addEventListener('scroll', toggleVisible);

		return () => {
			window.removeEventListener('scroll', toggleVisible);
		};
	}, []);

	return visible;
};
